<!--  台幣tag -->
<template>
  <div class="text-xs-left flex-grid">
    <div
      v-if="
        tagName === '主被保人' ||
        tagName === '要保人' ||
        tagName === '主約' ||
        tagName === '本人' ||
        tagName == '台幣'
      "
    >
      <div class="text-tag color-primary">{{ tagName }}</div>
    </div>
    <!--  金色 -->
    <div
      v-else-if="
        tagName === '公告' ||
        tagName === '配偶' ||
        tagName === '子女' ||
        tagName === '法定繼承人' ||
        tagName === '父母' ||
        tagName === '兄弟姊妹' ||
        tagName === '附約' ||
        tagName === '外幣'
      "
    >
      <div class="text-tag color-secondary">{{ tagName }}</div>
    </div>
    <!--  藍色 -->
    <div
      v-else-if="
        tagName === '證照' ||
        tagName === '祖孫' ||
        tagName === '其他' ||
        tagName === '要賠人' ||
        tagName === '婦嬰'
      "
    >
      <div class="text-tag color-accent">{{ tagName }}</div>
    </div>
    <!--  橘色 -->
    <div v-else-if="tagName === '訊息公告'">
      <div class="text-tag color-green">{{ tagName }}</div>
    </div>
    <!--  橘色 -->

    <div v-else>
      <div class="text-tag color-accent">{{ tagName }}</div>
    </div>
    <!--  其他角色 都是橘色 -->
    <slot name="content"></slot>
  </div>
</template>
<script>
export default {
  name: "base-tag",
  props: {
    tagName: String,
  },
};
</script>
<style lang="stylus" scoped>
.text-tag
  padding: 3px 12px;
  color: #fff;
  border-radius: 50px;
  font-weight: bolder;
  margin: 0 10px;
  word-break: keep-all;
  font-size: 14 px!important


.color-primary {
  background-color: $tag-primary !important;
  border-color: $tag-primary !important;
}

.color-secondary {
  background-color: $tag-secondary !important;
  border-color: $tag-secondary !important;
}

.color-accent {
  background-color: $tag-accent !important;
  border-color: $tag-accent !important;
}
.color-green {
  background-color: #40a637 !important;
  border-color: #40a637 !important;
}
</style>
